// extracted by mini-css-extract-plugin
export default {"section":"style_section__44mHc","sidePadding":"style_sidePadding__vaOwt","borderBottom":"style_borderBottom__bLWh6","secWhite":"style_secWhite__gtsbf"};